export const menuItems = [
	{
		id: 1,
		label: 'menuitems.menu.text',
		isTitle: true,
	},
	{
		id: 2,
		label: 'menuitems.menu.orders.text',
		icon: 'bx-basket',
		gate: 'order_access',
		subItems: [
			{
				id: 6,
				label: 'menuitems.menu.orders.list.orders',
				link: '/',
				parentId: 2,
				gate: 'order_access',
			},
			{
				id: 7,
				label: 'menuitems.menu.orders.list.status',
				link: '/order-statuses',
				parentId: 2,
				gate: 'order_status_access',
			},
			{
				id: 8,
				label: 'menuitems.menu.orders.list.origin',
				link: '/order-origins',
				parentId: 2,
				gate: 'order_origin_access',
			},
			{
				id: 9,
				label: 'menuitems.menu.orders.list.archived',
				link: '/archived-orders',
				parentId: 2,
				gate: 'order_access',
			},
		],
	},
	{
		id: 3,
		label: 'menuitems.menu.products.text',
		icon: 'bx-cube',
		gate: 'product_access',
		subItems: [
			{
				id: 10,
				label: 'menuitems.menu.products.list.products',
				link: '/products',
				parentId: 3,
				gate: 'product_access',
			},
			{
				id: 11,
				label: 'menuitems.menu.products.list.category',
				link: '/products-category',
				parentId: 3,
				gate: 'product_category_access',
			},
			{
				id: 12,
				label: 'menuitems.menu.products.list.type',
				link: '/products-type',
				parentId: 3,
				gate: 'product_type_access',
			},
		],
	},
	{
		id: 4,
		label: 'menuitems.menu.users.text',
		icon: 'bx-user',
		gate: 'user_access',
		subItems: [
			{
				id: 13,
				label: 'menuitems.menu.users.list.users',
				link: '/users',
				parentId: 4,
				gate: 'user_access',
			},
			{
				id: 14,
				label: 'menuitems.menu.users.list.customers',
				link: '/users/customers',
				parentId: 4,
				gate: 'user_access',
			},
			{
				id: 15,
				label: 'menuitems.menu.users.list.staff',
				link: '/users/staff',
				parentId: 4,
				gate: 'user_access',
			},
			{
				id: 16,
				label: 'menuitems.menu.users.list.admin',
				link: '/users/admin',
				parentId: 4,
				gate: 'user_access',
			},
			// {
			// 	id: 16,
			// 	label: 'menuitems.menu.users.list.roles',
			// 	link: '/users/roles',
			// 	parentId: 4,
			// },
			// {
			// 	id: 17,
			// 	label: 'menuitems.menu.users.list.permissions',
			// 	link: '/users/permissions',
			// 	parentId: 4,
			// },
		],
	},
	{
		id: 5,
		label: 'menuitems.menu.settings.text',
		icon: 'bx-cog',
		gate: 'setting_access',
		subItems: [
			{
				id: 17,
				label: 'menuitems.menu.settings.list.settings',
				link: '/settings',
				parentId: 5,
			},
		],
	},
];
